import { getDealerPatchesAndInfo } from "../queries/dealer/dealerFunctions";

export const PATCH_NOTIFICATION_KEY = "baana_patch_notification";
export const LAST_PATCH_CHECK_KEY = "baana_last_patch_check";

export const storePatchNotification = () => {
  localStorage.setItem(PATCH_NOTIFICATION_KEY, "true");
};

export const getPatchNotification = () => {
  return localStorage.getItem(PATCH_NOTIFICATION_KEY) === "true";
};

export const clearPatchNotification = () => {
  localStorage.removeItem(PATCH_NOTIFICATION_KEY);
};

export const checkForNewPatches = async () => {
  try {
    const lastCheck = localStorage.getItem(LAST_PATCH_CHECK_KEY);
    const serviceInfo = await getDealerPatchesAndInfo();
    const lastCheckTime = lastCheck ? Number.parseInt(lastCheck) : 0;

    if (serviceInfo?.updatedAt) {
      const lastUpdateTime = new Date(serviceInfo.updatedAt).getTime();

      if (lastUpdateTime > lastCheckTime) {
        storePatchNotification();
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error("Error checking for new patches:", error);
    return false;
  }
};

export const updateLastPatchCheck = () => {
  try {
    localStorage.setItem(LAST_PATCH_CHECK_KEY, Date.now().toString());
  } catch (error) {
    console.warn("Failed to update last patch check time:", error);
  }
};
